import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarDataPasienAdmin from "../../components/TopBarDataPasienAdmin";
import SemuaDataPasienAdmin from "../../components/SemuaDataPasienAdmin";
import "../../CSS/SemuaDataPasienAdmin.css";

function HalamanDataPasien() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarDataPasienAdmin />

        {/* Konten utama */}
        <div className="data-pasien-page">
          <SemuaDataPasienAdmin/>
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPasien;
